import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query, queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { preloadOptions } from '../Options/preloadOptions.ts';
import { shouldUseAGGActivityV3 } from '../shouldUseAGGActivityV3.ts';

import { getRecentQueryOptions } from './recentQueryHelpers.ts';
import { HomeRecentUserPreferencesQuery } from './HomeRecentQueries.graphql.ts';

export const preloadRecent = ({
	cloudId,
	isLoggedIn,
	isWhiteboardViewedEnabled,
	isWhiteboardUpdatedEnabled,
}: {
	cloudId: string;
	isLoggedIn: boolean;
	isWhiteboardViewedEnabled?: boolean;
	isWhiteboardUpdatedEnabled?: boolean;
}) => {
	return waitForAllReturnWhenError([
		(shouldUseAGGActivityV3() ? queryAgg : query)<unknown, {}>(
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			getRecentQueryOptions({
				pill: 'all',
				cloudId,
				endCursor: '',
				isWhiteboardViewedEnabled,
				isWhiteboardUpdatedEnabled,
			}),
		),
		preloadOptions({ isLoggedIn }),
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		...(isLoggedIn ? [query({ query: HomeRecentUserPreferencesQuery })] : []),
	]);
};
